import { getConfig } from './cacheManager';

/* eslint-disable no-param-reassign */
const defaults = {
  lifeTime: Infinity,
  staleTime: 0,
  debounceTime: 600,
};

export default ({ cache }) => {
  const config = getConfig();

  if (!cache.method) cache.method = 'get';
  if (!cache.getParams) cache.getParams = () => ({});
  if (!cache.getDependencies) cache.getDependencies = () => [];
  if (!cache.query) cache.query = {};
  if (!cache.transform) {
    cache.transform = config.transform ? config.transform : ({ data }) => data;
  }

  if (cache.lifeTime || cache.lifeTime === 0) {
    cache.lifeTime = cache.lifeTime === Infinity ? Infinity : cache.lifeTime * 60000;
  } else {
    cache.lifeTime = defaults.lifeTime;
  }
  if (cache.staleTime || cache.staleTime === 0) {
    cache.staleTime = cache.staleTime === Infinity ? Infinity : cache.staleTime * 60000;
  } else {
    cache.staleTime = defaults.staleTime;
  }
  if (!cache.debounceTime && cache.debounceTime !== 0) {
    cache.debounceTime = defaults.debounceTime;
  }
};
